import { render, staticRenderFns } from "./CustomRadioButton.vue?vue&type=template&id=8213e87c&scoped=true"
import script from "./CustomRadioButton.vue?vue&type=script&lang=js"
export * from "./CustomRadioButton.vue?vue&type=script&lang=js"
import style0 from "./CustomRadioButton.vue?vue&type=style&index=0&id=8213e87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8213e87c",
  null
  
)

export default component.exports